import React, { Component } from 'react'
// import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'
// import { AxiosUsersService } from "../../services/net/AxiosUsersService"
// import { UsersService } from "../../services/local/UsersService";
import 'whatwg-fetch'
// import { Redirect } from 'react-router-dom'
// import {NotificationService} from '../../services/local/NotificationService'


import { Button, Form, Grid, Header, Image, Message, Segment, Checkbox } from 'semantic-ui-react'


import { MyStore } from '../../../../services/Store'
import { Consumer } from '../../../../context/Context';
// import axios from 'axios';


import toaster from "toasted-notes";
import "toasted-notes/src/styles.css"; // optional styles


// const image2base64 = require('image-to-base64');
class Register extends Component {
    state = {
        email: '',
        password: '',
        displayName: '',
        errors: {},
        isSignUp: true
    };
 

 



    onChange = e => this.setState({ [e.target.name]: e.target.value });

    actionCodeSettings = {
        // Replace this URL with the URL where the user will complete sign-in.
        // url: 'localhost/finishSignUp?cartId=1234',
        url: 'http://localhost:3000/createAccount',
        handleCodeInApp: true,
        // dynamicLinkDomain: 'localhost'
      };
    
  
      

    onSubmit = async ( e) => {
        e.preventDefault();

        const { email, password, isSignUp } = this.state;

        if (email === '') {
            this.setState({ errors: { email: 'Email is required' } });
            return;
        }

        // if (password === '') {
        //     this.setState({ errors: { password: 'Password is required' } });
        //     return;
        // }

        // const newUser = { email, password, returnSecureToken: true };

        let url = '';

        if (isSignUp) {
            url = `https://www.googleapis.com/identitytoolkit/v3/relyingparty/signupNewUser?key=AIzaSyByPyCA_FQBPRd27kOB9rBnfbQMTP0_U3o`;
        } else {
            url = `https://www.googleapis.com/identitytoolkit/v3/relyingparty/verifyPassword?key=AIzaSyByPyCA_FQBPRd27kOB9rBnfbQMTP0_U3o`;
        }

        let resp = null;
        let expDate = null;
        try {
            // resp = await axios.post(url, newUser);
            // expDate = new Date(new Date().getTime() + resp.data.expiresIn * 1000);
            // localStorage.setItem('token', resp.data.idToken);
            // localStorage.setItem('expDate', expDate);
            // localStorage.setItem('userId', resp.data.localId);
            // dispatch({
            //     type: 'AUTH_LOGIN',
            //     payload: { token: resp.data.idToken, localId: resp.data.localId }
            // });
     
            console.log('-------------------- verify user ----------------')


            // user.sendEmailVerification().then(function(){
            //     console.log("email verification sent to user");
            //   });


            console.log('--------- email -------- ')
            console.log(email)

            MyStore.auth().sendSignInLinkToEmail(email, this.actionCodeSettings)
            .then(function() {
            // The link was successfully sent. Inform the user.
            // Save the email locally so you don't need to ask the user for it again
            // if they open the link on the same device.
            console.log('------ inside mystore.auth function ---------')
            window.localStorage.setItem('emailForSignIn', email);



           
            // header='Have you heard about our mailing list?'
            // content='Get the best news in your e-mail every day.'


            toaster.notify ((
                <div>         
                    <Message icon='mail'   color='blue' style={{width:"300px"}}
                     header='Check your Inbox to Finish Registration'
                     content='Do not close this page'
                    >
                      {/* <Message.Header> </Message.Header>
                      <Message.Content> </Message.Content> */}
                      {/* <p>Did you know it's been a while?</p> */}
                    </Message>
                </div>),{duration: 9999} )

            toaster.notify ((
                <div>         
                    <Message icon='clock' header='Time Sensitive'
                        content='For your security' style={{width:"250px"}} >
                      {/* <Message.Header>Time Sensitive </Message.Header> */}
                      {/* <p>Did you know it's been a while?</p> */}
                    </Message>
                </div>), {duration: 8000})
                

         

            })
            .catch(function(error) {
                console.log(error)
            // Some error occurred, you can inspect the code: error.code
            });


 
    



        } catch (error) {
            if (error.message === 'Request failed with status code 400') {
                this.setState({
                    errors: { response: 'User already exist, switch to Sign in' }
                });
            }

            if (
                !isSignUp &&
                error.message === 'Request failed with status code 400'
            ) {
                this.setState({
                    errors: { response: 'Invalid Email/Password' }
                });
            }
        }

        // const resp = await axios.post(url, newUser);

        if (resp) {
            // window.location.href = 'https://context-react-bootstrap.firebaseapp.com';
            // window.location.href = 'http://localhost:3000';
        }
    };

 

    render() {
        const { errors, isSignUp } = this.state;
        return (
            <div  >
 
                <Consumer>
                    {value => {
                        const { dispatch } = value;
                        return (
                            <Grid textAlign='center' style={{ minHeight: '80vh' }} verticalAlign='middle'>
                                <Grid.Column style={{ maxWidth: 450 }}>
                                    <Header as='h2' color='teal' textAlign='center'>
                                        <Image src='https://react.semantic-ui.com/logo.png' /> Register
                                </Header>

                                    <div className="login container pt-5">
                                        <div className="card border-0">
                               

                                            <Form size='large' onSubmit={e => this.onSubmit(  e)}>
                                            <Segment stacked  style={{
                                                                background: "transparent",
                                                                border: "1px solid transparent",
                                                                boxShadow: "none",
                                                                padding: "0em 0em",
                                            }} >

                                

                                                    <label style={{float:"left", padding:"10px"}}><Header> Email  </Header></label>
                                                    <Form.Input fluid icon='user' iconPosition='left' label='          ' placeholder='you@email.com'
                                                        name="email" value={this.state.email} onChange={this.onChange}
                                                        id="email" type="email"
                                                        className={'form-control form-control-lg ' + (errors.email ? 'is-invalid' : '')} />
                                                    <div className="invalid-feedback">{errors.email}</div>

                               

                                                    <div className="invalid-feedback">{errors.password}</div>
                                                    <div className="text-danger lead">
                                                        {errors.response ? errors.response : null}
                                                    </div>
                                                    {/* <Button color='teal' fluid size='large' onClick={this.onSubmitForm.bind(this)}> */}
                                                    <Button color='teal' fluid size='large'  >
                                                        Register
                                            </Button>

                                                </Segment>
                                            </Form>



                                        </div>
                                    </div>
                                </Grid.Column>
                            </Grid>
                        );
                    }}
                </Consumer>




            </div>
        );
    }
}

// http://localhost:3000/register?apiKey=AIzaSyByPyCA_FQBPRd27kOB9rBnfbQMTP0_U3o&oobCode=BdJJeoxojPBQTsvFS0QHjdisKoWEFRfKA1ldk6ZdcxkAAAFvDM9SEQ&mode=signIn&lang=en


// let  actionCodeSettings = {
//     // URL you want to redirect back to. The domain (www.example.com) for this
//     // URL must be whitelisted in the Firebase Console.
//     url: 'localhost/finishSignUp?cartId=1234',
//     // This must be true.
//     handleCodeInApp: true,
//     iOS: {
//       bundleId: 'com.example.ios'
//     },
//     android: {
//       packageName: 'com.example.android',
//       installApp: true,
//       minimumVersion: '12'
//     },
//     dynamicLinkDomain: 'localhost'
//   };
 
  const actionCodeSettings = {
    // Replace this URL with the URL where the user will complete sign-in.
    url: 'localhost/createAccount?cartId=1234',
    handleCodeInApp: true
  };

 

const options = [
    { key: 'a', text: 'Admin Organization', value: 'admin' },
    { key: 'c', text: 'Clinician', value: 'clinician' },
    { key: 'nc', text: 'Nurse/Coordinator', value: 'nurse_coordinator' },
  ]
  

 



export default Register


 